module.exports = __webpack_public_path__ + "img/80.5579d6a4.png";